import { render, staticRenderFns } from "./MintPBT.vue?vue&type=template&id=cff717c6"
import script from "./MintPBT.vue?vue&type=script&lang=js"
export * from "./MintPBT.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports